// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  envName: 'dev',
  production: false,
  title: 'TATTA Team Admin (試験環境)',
  amplify: {
    Auth: {
      Cognito: {
        region: 'ap-northeast-1',
        userPoolId: 'ap-northeast-1_9OU62d1z4',
        userPoolClientId: '3j8j5c4pivdjb8v5o2adtimomp',
        identityPoolId: 'ap-northeast-1:81add3f9-9e1d-447c-bcf5-b5d7784bcbb6',
      }
    },
    API: {
      REST: {
        'tatta-dev-admin-api': {
          endpoint: 'https://gb8khd5sdc.execute-api.ap-northeast-1.amazonaws.com/prod/',
          region: 'ap-northeast-1'
        }
      }
    }
  },
  tattaWebUrl: 'https://dev.tatta.runnet.jp',
  sentryDsn: 'https://f7ba73b29bbb4d71acb2ab2e50b45fbc@o1212003.ingest.sentry.io/6349844',
  // 不正利用防止のために念のためlocalhostでの利用は「localhost:4200/227/event/*」のパスでの利用しか許可をしていない
  googleMapApiKey: 'AIzaSyDDlRnR7DrSvFdvt_8Hq2dj-0e4TBVsqGA',
  moshicomUrl: 'https://preview2.moshicom.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
